class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.menuTabs = [];
    this.menuLists = [];
    this.navigationImageLinks = [];
    this.backButtons = [];
  }
  connectedCallback() {
    this.cacheDomElements();
    this.setEventListeners();
  }
  cacheDomElements() {
    this.closeButton = this.querySelector(
      ".mobile-menu__close-button"
    );
    this.menuTabs = Array.from(
      this.querySelectorAll("[js-mobile-menu='tab-item']")
    );
    this.menuLists = Array.from(
      this.querySelectorAll("[js-mobile-menu='menuList']")
    );
    this.navigationImageLinks = Array.from(
      this.querySelectorAll("[js-navigation-image-link]")
    );
    this.backButtons = Array.from(
      this.querySelectorAll("[js-mobile-menu='backButton']")
    );
  }
  setEventListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", (event) => {
        this.closeMobileMenu();
        this.resetMobileMenu();
        event.stopPropagation();
      });
    }
    this.menuTabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        this.handleMenuTab(tab);
      });
    });
    this.navigationImageLinks.forEach((link) => {
      link.addEventListener("click", () => {
        this.handleImageLinkClick(link);
      });
    });
    this.backButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.close2ndTier(button);
      });
    });
  }
  handleMenuTab(tab) {
    this.resetTier();
    const itemTitle = tab == null ? void 0 : tab.dataset.itemTitle;
    if (!itemTitle) {
      return;
    }
    const query = `[js-mobile-menu='menuList'][data-item-title='${itemTitle}']`;
    const matchingList = this.querySelector(query);
    if (!matchingList) {
      return;
    }
    tab.classList.add("is-active");
    matchingList.classList.add("is-open");
    this.removeClassFromOtherItems(this.menuTabs, tab, "is-active");
    this.removeClassFromOtherItems(this.menuLists, matchingList, "is-open");
  }
  handleImageLinkClick(link) {
    this.classList.add("show-tier2");
    const menuItem = link.closest(".mobile-menu__item");
    const tier2Menu = menuItem == null ? void 0 : menuItem.querySelector("[js-mobile-menu='tier2']");
    if (!tier2Menu) {
      return;
    }
    tier2Menu.classList.add("is-open");
  }
  /**
   * Checks from a list of elements for a specific element, and removes a
   * class names from all elements apart from the one specified.
   * @param elements - List of all the elements you want the specific class
   * removed from.
   * @param currentElement - Current element that you do not want class removed
   * from.
   * @param className - Class you want removing.
   */
  removeClassFromOtherItems(elements, currentElement, className) {
    elements.forEach((element) => {
      if (element !== currentElement) {
        element.classList.remove(className);
      }
    });
  }
  close2ndTier(backButton) {
    this.classList.remove("show-tier2");
    const tier2List = backButton.closest(".mobile-menu__list");
    tier2List == null ? void 0 : tier2List.classList.remove("is-open");
  }
  closeMobileMenu() {
    const nav = this.querySelector("nav");
    if (nav) {
      nav.classList.remove("is-open");
    }
    document.body.classList.remove("no-scroll");
  }
  /**
   * Calls resetTier function, as well as resets the active tab and list
   * back to the first ones
   */
  resetMobileMenu() {
    this.resetTier();
    this.menuTabs.forEach((tab, index) => {
      index == 0 ? tab.classList.add("is-active") : tab.classList.remove("is-active");
    });
    this.menuLists.forEach((list, index) => {
      index == 0 ? list.classList.add("is-open") : list.classList.remove("is-open");
    });
  }
  /**
   * Closes the second tier list by removing modifier class from component,
   * as well as removing modifier from tier
   */
  resetTier() {
    this.classList.remove("show-tier2");
    const openTier = this.querySelector(".mobile-menu__list--tier2.is-open");
    openTier == null ? void 0 : openTier.classList.remove("is-open");
  }
}
customElements.define("uwp-mobile-menu", MobileMenu);
